/**
 * ゾーンの枠を、カメラの生の絵の上に戻す（Issue #790。TetherCam のデバイスの「ゾーンの確認」）。純関数。
 * 補正サーバーの `LiveLayout.source_quad`（合成の矩形 → 補正前の絵）と同じ考え方: フィールドの 4 点で台形補正した
 * プレイマット（playmat_width × playmat_height）の上のゾーン（同梱マットの `layer_zones`）を、射影の逆で生の絵へ。
 * P2 のフィールドは合成で 180° 回して積むので、レイヤーの座標を回し戻してから戻す。
 */
import { FIELD_H, FIELD_W, LAYER_ZONES } from './defaultOverlayZones';
import { applyH, fromNormalized, homographyQuad, warpTarget } from './fieldPicker';

/**
 * @param {Array} entries デバイスの設定の entries（0〜1 の corners）
 * @param {number} w 生の絵の幅
 * @param {number} h 生の絵の高さ
 * @returns {Array<{key: string, player: number, points: number[][]}>} 生の絵の画素の 4 隅（左上・右上・右下・左下＝合成の向き）
 */
export function projectZones(entries, w, h) {
  const out = [];
  (entries ?? []).filter((e) => e.field_type === 'field').forEach((e) => {
    const pw = e.playmat_width ?? FIELD_W;
    const ph = e.playmat_height ?? FIELD_H;
    const H = homographyQuad(warpTarget(pw, ph), fromNormalized(e.corners, w, h));
    if (!H) return;
    const sx = pw / FIELD_W;
    const sy = ph / FIELD_H;
    const owner = e.player_number - 1;
    Object.entries(LAYER_ZONES).forEach(([key, z]) => {
      if (Number(key.split(':')[1]) !== owner) return;
      const box = [[z.x, z.y], [z.x + z.w, z.y], [z.x + z.w, z.y + z.h], [z.x, z.y + z.h]].map(([x, y]) => [x * sx, y * sy]);
      const mat = owner === 1 ? box.map(([x, y]) => [pw - x, ph - y]) : box;    // 180° 回したレイヤー → マットの向き
      out.push({ key, player: e.player_number, points: mat.map((p) => applyH(H, p)) });
    });
  });
  return out;
}
